<template>
  <div id="app">
    <div class="register-anime">
      <h2>Регистрация</h2>
      <div class="auth-block">
        
        <div class="auth-form">
          <label>Почта</label>
          <input class="email" type="email" name="email">
          <label>Логин (Nickname)</label>
          <input class="login" type="text" name="login">
          <label>Пароль</label>
          <input class="password" type="password" name="password">
          <button class="register-button" @click="register()">Зарегаться</button>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { isValid } from "ipaddr.js";



export default {
  data() {
    return {
      urlBasic: ""
    };
  },
  created(){
   
  },
  updated(){
    
  },
  methods: {
    register: function(){
      let email = document.querySelector('.email').value;
      let login = document.querySelector('.login').value;
      let password = document.querySelector('.password').value;
      
      if(this.isValid(login) && this.isValid(password) && this.isValid(email)){
        let url = `${window.location.protocol}//${window.location.hostname}/api/signup.php?username=${login}&password=${password}&email=${email}`;
        axios
        .get(url)
        .then((response) => {
          if(response.data){
            console.log(response.data);
            alert('Вы зарегистрированы!');
            window.location.pathname = '/auth';
          }else{
            alert('Такой пользователь или эта почта уже существует! Измените данные.');
          }
          
        })
        .catch((error) => {
          console.error(error);
        });
      }
      
    },
    isValid: function(value){
      const cyrillicPattern = /[А-Яа-я]/;
      let isValidValue = false;
      if(value.length >= 3){
        isValidValue = true;
      }
      if(value.length < 3){
        alert('Логин или пароль слишком короткие');
        return false;
      }
      if(!cyrillicPattern.test(value)){
        isValidValue = true;
      }
      if(cyrillicPattern.test(value)){
        console.log('nor cyrilic');
        alert('Логин(Nickname) не может содержать кириллицу');
        return false;
      }
      return isValidValue;
    },
    auth_hash: function(){
      
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        console.log('asd');
        let url = `${window.location.protocol}//${window.location.hostname}/api/signin.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;

        axios
        .get(url)
        .then((response) => {
          if(response.data){
            console.log(response.data);
          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
          
        })
        .catch((error) => {
          alert('Срок сессии истек. Авторизуйтесь заново.')
          console.error(error);
        });
      }

      
    }
  }
};
</script>

<style>
.auth-block{
  display: flex;
  justify-content: center;
}

.auth-form{
  display: flex;
  width: 300px;
  flex-direction: column;
}

.register-anime .auth-form input{
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  font-family: 'Exo 2', sans-serif;
  font-size: 18px;
}

.register-anime .auth-form label{
  padding: 10px 0 5px 0;
  font-family: 'Montserrat', sans-serif;
}

.register-anime .auth-form button{
  padding: 5px 10px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-family: 'Montserrat';
  margin-top: 10px;
  cursor: pointer;
}

.register-anime .auth-form .register-button{
  color: white;
  background-color: #0d6efd;
}

</style>